import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'kt-panel',
    template: `<div class="card" [style.margin-bottom.px]="10">
  <h5 class="card-header">
    <span>{{ props.label }}</span>
    @if(props.required) {
      <span>*</span>
    }
  </h5>
  <div class="card-body">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
`,
    standalone: false
})
export class FormlyWrapperPanelComponent extends FieldWrapper {

}
